import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { FastClick } from 'searchkit';
import SearchKitContext from '../../pages/DashboardPage/SearchKitContext';

function SearchError({ errorLabel, bemBlocks, tryAgainLabel }) {
  const [retried, setRetried] = useState(false);
  const { searchkit } = useContext(SearchKitContext);
  useEffect(() => {
    if (!retried) {
      searchkit.reloadSearch();
      setRetried(true);
    }
  }, [retried, searchkit, setRetried]);
  return (
    <div data-qa="no-hits" className={bemBlocks.container()}>
      <div className={bemBlocks.container('info')}>{errorLabel}</div>
      <div className={bemBlocks.container('steps')}>
        <FastClick handler={() => window.location.reload()}>
          <div className={bemBlocks.container('step-action')}>{tryAgainLabel}</div>
        </FastClick>
      </div>
    </div>
  );
}

SearchError.propTypes = {
  errorLabel: PropTypes.string.isRequired,
  bemBlocks: PropTypes.object.isRequired,
  tryAgainLabel: PropTypes.string.isRequired,
};

export default SearchError;
